//La función fusiona las propiedades de dos objetos, asignando 
//los valores de object2 a object1 si existe una coincidencia 
//de propiedad, y estableciendo las propiedades de object1 en una 
//cadena vacía si no hay una coincidencia.
function mergeProps(object1, object2) {
  for (const prop in object1) {
    if (object1.hasOwnProperty(prop) && object2.hasOwnProperty(prop)) {
      object1[prop] = object2[prop];
    } else {
      object1[prop] = "";
    }
  }
  return object1;
}

export default mergeProps;